module.exports = __webpack_public_path__ + "img/icon-doctor.da941d0.svg";